import apiSlice from '@/features/apiSlice'
import User from '@/types/User'
import { apiUsers } from '@/routes'

const apiSliceWithCurrentUser = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentUser: builder.query<User, void>({
      query: () => apiUsers.me(),
    }),
  }),
})

export function userCurrentUser() {
  const { data } = useGetCurrentUserQuery()

  return data
}

export const { useGetCurrentUserQuery } = apiSliceWithCurrentUser
